<template>
  <div class="tir-pm-kanban">
    <div class="tir-pm-kanban__scroller">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts" setup />

<style lang="scss">
@import "./style.scss";
</style>
